import { Controller } from "react-hook-form";
import VirtualScrollDropdown from "../../../Core/virtual-scroll-dropdown/VirtualScrollDropdown";
import styles from "../../style.module.scss";

const FormDropdown = ({
    name, control, errors, code, onOptionSelect, required = false, disabled = false,
    label = "", placeholder = "", valueMode = "label", labelField = "nameRu"
}) => {
    const getValueFromOption = (option) => {
        if (!option) {
            return valueMode === "label" ? "" : null;
        }

        switch (valueMode) {
            case "label":
                return option.nameRu ?? "";
            case "object":
                return option;
            default:
                return option.id ?? null;
        }
    };

    return (
        <div className={`p-d-flex p-flex-column ${styles.formFieldContainer}`}>
            {label !== "" && <label className={required ? styles.requiredLabel : ""} htmlFor={name}>{label}</label>}
            <Controller
                name={name}
                control={control}
                rules={required ? {required: "Поле обязательно для заполнения"} : undefined}
                render={({field}) => {
                    const { onChange, value } = field;

                    return (
                        <VirtualScrollDropdown
                            mode="billing"
                            code=""
                            searchCode={code}
                            placeholder={placeholder}
                            disabled={disabled}
                            initialValue={value || null}
                            labelField={labelField}
                            onChange={(option) => {
                                console.log(option);
                                onChange(getValueFromOption(option));

                                if (typeof onOptionSelect === "function") {
                                    onOptionSelect(option);
                                }
                            }}
                        />
                    )
                }}
            />
            {errors?.[name] && (
                <small className="p-error">
                    {errors[name].message}
                </small>
            )}
        </div>
    );
};

export default FormDropdown;